import { useState } from "react";
import type { GalaxyState } from "../../types/galaxy";

interface Props {
  galaxyState: GalaxyState;
  courseTarget: string | null;
  onConfirmWarp: () => void;
  onCancelCourse: () => void;
  onEnterOrbit: () => void;
}

export function NavigationControls({
  galaxyState,
  courseTarget,
  onConfirmWarp,
  onCancelCourse,
  onEnterOrbit,
}: Props) {
  const [showConfirm, setShowConfirm] = useState(false);

  const targetSystem = courseTarget
    ? galaxyState.systems.find(s => s.id === courseTarget)
    : null;

  const currentSystem = galaxyState.systems.find(
    s => s.id === galaxyState.player.location
  );

  const distance = targetSystem && currentSystem
    ? Math.sqrt(
        (targetSystem.position.x - currentSystem.position.x) ** 2 +
        (targetSystem.position.y - currentSystem.position.y) ** 2
      )
    : 0;

  const travelHours = Math.max(0.5, distance * 2);
  const isAtTarget = courseTarget === galaxyState.player.location;

  const handleWarpClick = () => {
    if (isAtTarget) {
      onEnterOrbit();
      return;
    }
    setShowConfirm(true);
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    onConfirmWarp();
  };

  const handleCancel = () => {
    setShowConfirm(false);
    onCancelCourse();
  };

  return (
    <div className="nav-controls">
      {/* Warp confirmation modal */}
      {showConfirm && targetSystem && (
        <div className="nav-confirm-overlay">
          <div className="nav-confirm-modal">
            <div className="nav-confirm-title">CONFIRM COURSE</div>
            <div className="nav-confirm-system">{targetSystem.name}</div>
            <div className="nav-confirm-detail">
              {targetSystem.region}
            </div>
            <div className="nav-confirm-detail">
              Distance: {distance.toFixed(1)} ly — Est. travel: {travelHours.toFixed(1)} hours
            </div>
            <div className="nav-confirm-actions">
              <button className="nav-btn nav-btn-warp" onClick={handleConfirm}>
                ENGAGE WARP
              </button>
              <button className="nav-btn nav-btn-cancel" onClick={handleCancel}>
                CANCEL
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Bottom bar */}
      <div className="nav-bar">
        {courseTarget && targetSystem ? (
          <>
            <div className="nav-course-info">
              <span className="nav-label">COURSE SET:</span>
              <span className="nav-target">{targetSystem.name}</span>
              <span className="nav-distance">{distance.toFixed(1)} ly</span>
            </div>
            <div className="nav-bar-actions">
              <button className="nav-btn nav-btn-cancel-small" onClick={handleCancel}>
                CLEAR
              </button>
              <button className="nav-btn nav-btn-warp" onClick={handleWarpClick}>
                {isAtTarget ? "ENTER ORBIT" : "SET COURSE"}
              </button>
            </div>
          </>
        ) : (
          <div className="nav-idle">
            <span className="nav-label">SELECT A DESTINATION</span>
            <span className="nav-hint">Click a system on the map or choose a mission</span>
          </div>
        )}
      </div>
    </div>
  );
}
